var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckTick = function SvgCheckTick(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    fill: "none",
    viewBox: "0 0 17 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m1.5 6.5 4.517 5.225.4-.701a28.599 28.599 0 0 1 8.7-9.42L16 1"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckTick);
export default ForwardRef;